<template>
  <div class="video-content">
    <div
      class="video-content__wrapper"
      :class="isMobile ? 'mobile' : 'desktop'"
    >
      <div
        v-for="(video, index) of videos"
        :key="index"
        class="video-content__video-container"
      >
        <video
          ref="video"
          :src="video.sources[0].url"
          autoplay
          muted
          loop
          playsinline
          @click="togglePlay(index)"
        />
        <button
          type="button"
          class="video-content__play-pause-button"
          @click="togglePlay(index)"
        >
          <icon-play v-if="!isPlaying[index]" />
          <icon-pause v-else />
        </button>
      </div>
    </div>
  </div>
</template>

<script>

/**
 * Vue: video-content (video-content)
 * -----------------------------------------------------------------------------
 * video content customization.
 *
 * @param {String} liquid.sectionId - Section's Liquid ID.
 *
 */
import { Swiper, SwiperSlide } from 'swiper/vue'
import { mapState } from 'vuex'
import IconPlay from '~icons/misc/play.svg'
import IconPause from '~icons/misc/pause.svg'
export default {
  name: 'VideoContent',
  components: {
    Swiper,
    SwiperSlide,
    IconPlay,
    IconPause,
  },
  props: {
    videos: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      isPlaying: [true, true, true],
    }
  },
  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      isMobile: (state) => state.index.screen.mobile,
    }),
  },
  methods: {

    /**
     * Methods to toggle play pause event on video.
     */
    togglePlay(index) {
      const video = this.$refs.video[index]
      if (video.paused) {
        video.play()
        this.isPlaying[index] = true
      } else {
        video.pause()
        this.isPlaying[index] = false
      }
    },
  },
}
</script>

<style lang="scss">
@import './video-content';
</style>
